import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import trans_en_GB from "./translations/en";
import trans_ar_EG from "./translations/ar";
import qr_en from "./translations/qr/en";
import qr_ar from "./translations/qr/ar";
import qr_fr from "./translations/qr/fr";
import qr_es from "./translations/qr/es";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: trans_en_GB,
      qr: qr_en,
    },
    ar: {
      translation: trans_ar_EG,
      qr: qr_ar,
    },
    // French/Spanish are QR-only — the portal stays en/ar.
    fr: {
      qr: qr_fr,
    },
    es: {
      qr: qr_es,
    },
  },
  lng: "en",
  fallbackLng: "en",
  ns: ["translation", "qr"],
  defaultNS: "translation",
  // A missing "qr" key falls back to the portal "translation" namespace,
  // then to English — so a gap degrades gracefully instead of showing the key.
  fallbackNS: "translation",
  debug: false,

  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18n;
